import styled from '@emotion/styled';
import { layers } from 'app/spacing';
import IconButtonMenu from 'components/Kizen/IconButtonMenu';

export const StyledIconButtonMenu = styled(IconButtonMenu)`
  .IconButtonMenu__menu {
    z-index: ${layers.modal};
  }
`;
